import Mutations from '../../odata/mutations';

export default { ...new Mutations('canningProcess'), ...new Mutations('canningProcesses') };
